import React, {useRef, useState} from 'react';
import {ScheduledTasksApi} from "api/ScheduledTasksApi";
import {ScheduledTaskDTO} from "api/model/airflow-task/ScheduledTaskDTO";
import {Dialog} from 'primereact/dialog';
import {Button} from 'primereact/button';
import {Instant} from '@js-joda/core';
import {Menu} from 'primereact/menu';
import {SplitButton} from 'primereact/splitbutton';
import {T} from 'services/lang/LanguageService';
import CalendarWrapper from 'components/basic/calendar-wrapper/CalendarWrapper';


interface TaskDataDownloadDialogProps {
    taskCfg: ScheduledTaskDTO;
}

function TaskDataDownloadButton(props: TaskDataDownloadDialogProps) {
    const menu = useRef<Menu>(null);

    const [date, setDate] = useState(new Date());
    const [invalid, setInvalid] = useState(false);
    const [showDialog, setShowDialog] = useState(false);

    const menuItems = [
        {
            label: T("action.download-now"),
            icon: "pi pi-download",
            command: () => openDataLink(),
        },
        {
            label: T("action.download-at"),
            icon: "pi pi-calendar",
            command: () => openDialog(),
        }
    ];

    const openDialog = () => {
        setShowDialog(true);
        setDate(new Date());
    }

    const openDataLink = (refTime: Instant = Instant.now()) => {
        const link = ScheduledTasksApi.getAirflowTaskJobDataLink(props.taskCfg.parentId!!, props.taskCfg.id!!, refTime)
        window.open(link);
    }

    const handleDateChange = (currentDate: Date) => {
        if(isNaN(currentDate.valueOf())) {
            setInvalid(true)
        } else {
            setDate(currentDate);
            setInvalid(false)
        }
    }

    const dialogSubmit = () => {
        openDataLink(Instant.ofEpochMilli(date.getTime()));
        setShowDialog(false)
    }

    return <>
        <Menu model={menuItems} popup ref={menu} id="popup-menu-data-dl" />
        <SplitButton
            label={`${T("word.data")} JSON...`}
            icon="pi pi-download"
            className="p-button-pain"
            model={menuItems}
            onClick={() => openDataLink()}
        />

        <Dialog header={T("label.download-task-data-json")} visible={showDialog} onHide={() => setShowDialog(false)} style={{width: '300px'}}>
            <div className="p-fluid grid formgrid">
                <div className="p-field p-col-12">
                    <span>
                        { !invalid && <span>{T("word.reference-date")}</span>}
                        { invalid && <>
                            {T("error.invalid-date")}
                            <i className="pi pi-exclamation-triangle ml-2" style={{color: "crimson"}} />
                        </>}
                    </span>
                    <CalendarWrapper
                        value={date}
                        onChange={handleDateChange}
                    />
                </div>

                <div className="p-field p-col-12">
                    <Button label={T("action.download")}
                            icon="pi pi-download"
                            className="p-button-success"
                            onClick={dialogSubmit}
                            disabled={invalid}
                    />
                </div>
            </div>
        </Dialog>
    </>
}

export default TaskDataDownloadButton;